import { Component, inject } from '@angular/core';
import {
  trigger,
  transition,
  style,
  animate,
  animation,
  query,
  group,
} from '@angular/animations';
import { SurveyInitialsing } from '../survey-initialsing/survey-initialsing';
import { SurveyNotFound } from '../survey-not-found/survey-not-found';
import { SurveyLogin } from '../survey-login/survey-login';
import { SurveyLoading } from '../survey-loading/survey-loading';
import { SurveyPage } from '../survey-page/survey-page';
import { SurveyCompleted } from '../survey-completed/survey-completed';
import { SurveyExpired } from '../survey-expired/survey-expired';
import { RenderStates, SurveyRenderControllerStore } from '../../render-store/render.store';
import { UnifiedSurveyStore } from '../../render-store/unified-survey.store';
import { SurveyErrorOccured } from "../survey-error-occured/survey-error-occured";

@Component({
  selector: 'lib-survey-render-main',
  imports: [
    SurveyInitialsing,
    SurveyLogin,
    SurveyLoading,
    SurveyPage,
    SurveyCompleted,
    SurveyExpired,
    SurveyErrorOccured
],
  templateUrl: './survey-render-main.html',
  styleUrl: './survey-render-main.css',
  animations: [
    trigger('typeformTransition', [
      transition('* => *', [
        style({ position: 'relative', minHeight: '400px' }), // Keep height stable

        query(
          ':enter, :leave',
          [
            style({
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
            }),
          ],
          { optional: true },
        ),

        group([
          // The old state slides UP and fades OUT
          query(
            ':leave',
            [
              animate(
                '400ms cubic-bezier(0.4, 0.0, 0.2, 1)',
                style({ opacity: 0, transform: 'translateY(-20px)' }),
              ),
            ],
            { optional: true },
          ),

          // The new state starts slightly BELOW and slides UP into place
          query(
            ':enter',
            [
              style({ opacity: 0, transform: 'translateY(20px)' }),
              animate(
                '450ms 100ms cubic-bezier(0.4, 0.0, 0.2, 1)',
                style({ opacity: 1, transform: 'translateY(0)' }),
              ),
            ],
            { optional: true },
          ),
        ]),
      ]),
    ]),
  ],
})
export class SurveyRenderMain {
  protected title = 'respondent-embed';

  surveyRenderStore = inject(SurveyRenderControllerStore);
  surveyBotStore = inject(UnifiedSurveyStore);

  RENDER_STATES = RenderStates;
}
